import moment from 'moment';

import AutoStartValidators from './autoStart'
import AutoStopValidators from './autoStop'

const DATE_FMT = 'YYYY-MM-DD'
const TIME_FMT = 'HH:mm:ss'
const FULL_DT_FMT = [DATE_FMT, TIME_FMT].join(' ')

const isBool = value => typeof value === 'boolean';
const length = value => !!value === true && !!value.length;


const isValidEstRuntime = value => {
    if (!value) return true;
    return value.length === 5;
}

const isValidDateTime = value => {
    try {
        if (moment.isMoment(value)) {
            return value.isValid()
        } else {
            return moment(value, FULL_DT_FMT).isValid();
        }
    } catch (error) {
        console.trace('Validator::isValidDateTime', error);
    }
}

let AutoStartRule = {
    required: false,
    group: 'automation',
    description: [
        'If AutoStart is On both the Start Date and Start Time must be provided',
        'If AutoStart is On the Start Date/Time must begin no earlier than the current time + 10 minutes',
        'If AutoStart is On the Preroll is checked against the provided Start Date/Time and must validate on the rule above'
    ],
    validators: [
        isBool
    ].concat(AutoStartValidators)
}

let AutoStopRule = {
    required: false,
    group: 'automation',
    description: [
        'If AutoStop is turned on both the Stop Date and Stop Time must be provided.',
        'If AutoStop is turned on the Stop Date/Time must fall after the provided Start Date/Time.',
        'Additionally, the Stop Date/Time must occurr no less than 10 minutes after the provided Start Date/Time'
    ],
    validators: [
        isBool
    ].concat(AutoStopValidators)
}

let StopDateRule = {
    required: false,
    group: 'automation',
    description: 'Stop Date must occur on or after the Start Date provided.',
    validators: [
        isValidDateTime,
        (function (value, data) {
            if (data.autoStop === true) {
                if (!!data.stopTime === false) return false
                let startDate = moment(
                    data.startDateTime.split(' ')[0],
                    DATE_FMT
                )

                // must be on or after startDate
                return startDate.isSameOrBefore(value)
            }
            return true
        })
    ]
}

let StopTimeRule = {
    required: false,
    group: 'automation',
    description: 'Stop Time must occur on or after the Start Time provided + 10 minutes.',
    validators: [
        isValidDateTime,
        (function (value, data) {
            if (data.autoStop === true) {
                if (!!data.stopDate === false) return false
                let startDateTime = moment(
                    data.startDateTime,
                    FULL_DT_FMT
                )

                let autoStopTime =  moment([
                    data.stopDate.format(DATE_FMT),
                    value.format(TIME_FMT)
                ].join(' '))

                let threshold = startDateTime
                    .add(10, 'minutes')
                    .startOf('minute')

                // must be on or after startTime
                return autoStopTime.isSameOrAfter(threshold)
            }
            return true
        })
    ]
}


// @TODO
// notes: null,
// streamtext: null,
// stopDateTime: null,
// autoStop: null,
// preroll: null,
// assignedEncoder: null,
export default {
    event: {
        title: {
            required: true,
            group: 'general',
            description: 'The Event Title is Required',
            validators: [
                length
            ]
        },
        startDateTime: {
            required: true,
            group: 'general',
            validators: [
                isValidDateTime
            ]
        },
        // description: {
        //     required: false,
        //     group: 'general',
        //     validators: [
        //         length
        //     ]
        // },
        private: {
            required: false,
            group: 'general',
            validators: [
                isBool
            ]
        },
        estRuntime: {
            required: false,
            group: 'general',
            description: 'The Estimated Runtime is Invalid',
            validators: [
                isValidEstRuntime
            ]
        },
    },
    automation: {
        autoStart: AutoStartRule,
        autoStop: AutoStopRule,
        stopDate: StopDateRule,
        stopTime: StopTimeRule
    }
};
